<template>
  <span>
    Physician Acknowledgement: <b>{{ condition.signed ? 'Yes' : 'No' }}</b>
  </span>
</template>
<script>

export default {
  name: 'BloodTransfusionSigned',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
